import React from 'react';

const TitleMain = (props) => {
  const { language } = props;

  return (
    <section className="module-title">
      <h2>
        {language.nav.menu.reports}
      </h2>
    </section>
  )
};

export default TitleMain;



// WEBPACK FOOTER //
// ./source/client/components/reports/title.jsx